'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.load = load;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'page/LOAD';

var initialState = {};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        title: action.title
      });
    default:
      return state;
  }
}

function load(i18n, page) {
  return {
    type: LOAD,
    page: page,
    title: i18n[page].title
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/modules/page.js
// module id = 591
// module chunks = 0